import { faker } from '@faker-js/faker';
import { Factory } from 'miragejs';

export default Factory.extend({
  name() {
    return faker.music.songName();
  },

  order() {
    return faker.datatype.number(10);
  },

  afterCreate(productElement, server) {
    productElement.update({
      category: server.create('category', 'contributorFunction'),
    });

    // if (!productElement.product) {
    //   productElement.update({
    //     product: server.create('product'),
    //   });
    // }
  },
});
